import { map, mergeMap } from "rxjs/operators";
import env from "src/core/env";
import { Repository } from "src/core/Repository";
import {
  DataRequestFormRequest,
  DataRequestFormResponse,
  ExportDataRequestFormRequest,
  ListDataRequestFormRequest,
  ListDataRequestFormResponse,
} from "src/models/DataRequestForm";
import { ExportFileResponse } from "src/models/report";

class DataRequestFormRepository extends Repository<
  DataRequestFormRequest,
  DataRequestFormResponse,
  ListDataRequestFormRequest,
  ListDataRequestFormResponse
> {
  protected basePath = "api/cms-service/data-request-form";

  constructor() {
    super(env.API_CMS_URL);
  }

  export({ id, fileType }: ExportDataRequestFormRequest) {
    return this.request<ExportFileResponse>({
      method: "post",
      url: `/${id}/export`,
      params: { fileType },
    }).pipe(
      mergeMap(({ data }) => {
        return this.api
          .get<Blob>("api/File/DownloadTempFile", data, {
            responseType: "blob",
          })
          .pipe(
            map(({ data: fileData }) => ({
              fileName: data.fileName,
              fileContent: fileData,
            }))
          );
      })
    );
  }

  exportToView(id: string) {
    return this.request<string>({
      method: "post",
      url: `/${id}/export-to-view`,
    });
  }
}

export default new DataRequestFormRepository();
